'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styles$m = require('./styles-8735da64.js');

var PageTitleTw = function (_a) {
    var text = _a.text, iconType = _a.iconType, iconName = _a.iconName, iconText = _a.iconText, onIconClick = _a.onIconClick, dataTestId = _a.dataTestId, className = _a.className;
    var handleOnKeyDown = React.useCallback(function (e) {
        e.stopPropagation();
        var isPressKey = (e.keyCode === constants.ENTER_KEY || e.keyCode === constants.SPACE_KEY);
        if (onIconClick && isPressKey) {
            onIconClick();
        }
    }, [onIconClick]);
    return (React__default.createElement(styles$m.Container, { className: className, "data-testid": dataTestId },
        iconText && onIconClick && (React__default.createElement(styles$m.IconTextContainer, { className: "icon-text", "data-test-id": "icon-text-clickable", tabIndex: 0, role: "button", onKeyDown: handleOnKeyDown, onClick: onIconClick },
            React__default.createElement(styles$m.Icon, { className: "icon", icon: [iconType || 'far', iconName || 'arrow-left'] }),
            iconText)),
        React__default.createElement(styles$m.Title, { className: "title", hasIcon: !!iconText }, text)));
};

exports.PageTitleTw = PageTitleTw;
